import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getCurrentLocation, getFilters } from '@modules/nav/selectors';
import {
  MSG_EHR_SYNC_SUCCESS,
  MSG_EHR_SYNC_FAILED,
  MSG_EHR_SYNC_FINISHED,
} from '@utils/enums/messages';
import {
  messageError,
  messageSuccess,
} from '@views/base-components/toast-messages';
import SDK from '@utils/api';
import WS from '@utils/api/ws';
import {
  listEhrSyncIssues,
  listEhrSyncInfo,
  syncLeadById,
  syncAllLeads,
  modalClean,
  modalOpenSetNotFound,
  modalTriggerNotFound,
  ehrSyncManualAll,
  ehrSyncManualItemsFinish,
} from './actions';
import { SOCKET_EVENT_SYNC_ALL_LEADS, SOCKET_EVENT_SYNC_LEAD } from './types';
import { getListEhrSyncItems } from './selectors';

export function* getListEhrSyncIssuesSaga() {
  try {
    yield put(listEhrSyncIssues.request());
    const filters = yield select(getFilters);
    const api = yield call([SDK, 'getApi']);
    const { body } = yield call([api.leads, 'getLeadsNextech'], filters);
    yield put(listEhrSyncIssues.success(body));
  } catch (error) {
    yield put(listEhrSyncIssues.failure(error));
  } finally {
    yield put(listEhrSyncIssues.fulfill());
  }
}

export function* getListInfoSaga() {
  try {
    yield put(listEhrSyncInfo.request());

    const api = yield call([SDK, 'getApi']);
    const { body } = yield call(
      [api['system-metadata'], 'getKeySystemMetadata'],
      {
        key: 'ehr_sync',
      },
    );
    yield put(listEhrSyncInfo.success(body));
  } catch (error) {
    yield put(listEhrSyncInfo.failure(error));
  } finally {
    yield put(listEhrSyncInfo.fulfill());
  }
}

export function* syncAllLeadsSaga() {
  try {
    yield put(syncAllLeads.request());
    const socket = yield call([WS, 'getWs']);
    socket.emit(SOCKET_EVENT_SYNC_ALL_LEADS);
    yield put(syncAllLeads.success());
  } catch (error) {
    yield put(syncAllLeads.failure(error));
  } finally {
    yield put(syncAllLeads.fulfill());
  }
}

export function* syncLeadAllNotificationSaga({ payload }) {
  const location = yield select(getCurrentLocation);
  if (
    payload.syncManualAll === false &&
    location.pathname === '/app/ehr-sync-issues'
  ) {
    yield call(messageSuccess, MSG_EHR_SYNC_FINISHED);
  }
}

export function* syncLeadByIdSaga({ payload }) {
  try {
    yield put(syncLeadById.request());
    const socket = yield call([WS, 'getWs']);
    socket.emit(SOCKET_EVENT_SYNC_LEAD, { id: payload });
    yield put(syncLeadById.success());
  } catch (error) {
    yield put(syncLeadById.failure(error));
  } finally {
    yield put(syncLeadById.fulfill());
  }
}

export function* syncLeadFinishSaga({ payload }) {
  const location = yield select(getCurrentLocation);
  if (location.pathname === '/app/ehr-sync-issues') {
    if (payload.isSyncing === true) {
      const leads = yield select(getListEhrSyncItems);
      const lead = leads.find((item) => item.id === payload.id);
      yield call(messageSuccess, MSG_EHR_SYNC_SUCCESS);
      if (lead) {
        yield call(listEhrSyncIssues);
      }
    } else {
      yield call(messageError, MSG_EHR_SYNC_FAILED, true);
    }
  }
}

export function* modalNotFoundSaga({ payload }) {
  try {
    yield put(listEhrSyncIssues.request());
    yield put(modalClean());
    yield put(
      modalOpenSetNotFound({
        isOpen: true,
        leadId: payload.id,
        title: payload.title,
        message: payload.message,
      }),
    );
  } catch (error) {
    yield put(listEhrSyncIssues.failure(error));
  } finally {
    yield put(listEhrSyncIssues.fulfill());
  }
}

export default function* ehrSyncWatcher() {
  yield takeEvery(listEhrSyncIssues.TRIGGER, getListEhrSyncIssuesSaga);
  yield takeEvery(listEhrSyncInfo.TRIGGER, getListInfoSaga);
  yield takeEvery(syncAllLeads.TRIGGER, syncAllLeadsSaga);
  yield takeEvery(syncLeadById.TRIGGER, syncLeadByIdSaga);
  yield takeEvery(modalTriggerNotFound.toString(), modalNotFoundSaga);
  yield takeEvery(ehrSyncManualItemsFinish.toString(), syncLeadFinishSaga);
  yield takeEvery(ehrSyncManualAll.toString(), syncLeadAllNotificationSaga);
}
